import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import styles from './Loader.module.scss';

type LoaderProps = {
  isVisible: boolean;
  fullscreen: boolean;
  theme: 'dark' | 'light';
};

export default function Loader({
  isVisible,
  fullscreen,
  theme,
}: LoaderProps) {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    let mounted = true;
    let timer1: ReturnType<typeof setTimeout>;

    if (!isVisible && mounted) {
      timer1 = setTimeout(() => {
        setHide(true);
      }, 400);
    }

    return () => {
      mounted = false;
      if (timer1) clearTimeout(timer1);
    };
  }, [isVisible]);

  return (
    <div
      className={clsx(
        styles.outerWrapper,
        theme === 'dark' ? styles.themeDark : styles.themeLight,
        isVisible ? styles.visible : styles.hiddenOpacity,
        fullscreen ? styles.positionFullscreen : styles.positionInline,
      )}
      style={{ display: hide ? 'none' : 'flex' }}
    >
      <div className={styles.innerWrapper}>
        <div className={styles.centerDot} />

        <div className={styles.innerSpinner}>
          <div className={styles.innerDot} />
          <div className={styles.innerDot} />
          <div className={styles.innerDot} />
          <div className={styles.innerDot} />
        </div>

        <div className={styles.outerSpinner}>
          <div className={styles.outerDot} />
          <div className={styles.outerDot} />
          <div className={styles.outerDot} />
          <div className={styles.outerDot} />
        </div>
      </div>
    </div>
  );
}
